import React from "react";
import classes from "./ErrorElement.module.css";

function ErrorElement() {
  return (
    <div className={classes["notfound"]}>
      <img src={"/images/laptop-robots.svg"} className={classes["errr-robots"]} />
      <h1>404</h1>
      <h2>We are sorry, Page not found!</h2>
      <p>
        The page you are looking for might have been removed had its name
        changed or is temporarily unavailable.
      </p>
    </div>
  );
}

export function ErrorElementRoute() {
  return (
    <div className={classes["error-container"]}>
      <img src={"/images/robot-404.svg"} className={classes["laptop-robots"]} />
      <h2>Some Problem occured!</h2>
      <p>Please Refresh</p>
    </div>
  );
}

export default ErrorElement;
